import { LATEST_CONTENT_FETCH_DONE, FETCH_STARTED, LATEST_CONTENT_FETCH_FAILED } from '../actions/actionTypes'

const initialState = {
  contents: [],
  fetching: false,
  error: ''
}

export const latestContents = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STARTED: {
      return {
        ...state,
        fetching: true
      }
    }
    case LATEST_CONTENT_FETCH_DONE: {
      return {
        ...state,
        contents: action.payload.data,
        fetching: false
      }
    }
    case LATEST_CONTENT_FETCH_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
